export const truckForSaleFieldConfig = [
  {
    name: "unitNumber",
    label: "Unit Number",
    type: "text",
    validation: {
      required: "Unit Number is required",
      maxLength: { value: 50, message: "Unit Number must not exceed 50 characters" },
    },
  },
  {
    name: "make",
    label: "Make",
    type: "text",
    validation: {
      required: "Make is required",
      maxLength: { value: 50, message: "Make must not exceed 50 characters" },
    },
  },
  {
    name: "model",
    label: "Model",
    type: "text",
    validation: {
      required: "Model is required",
      maxLength: { value: 15, message: "Model must not exceed 15 characters" },
    },
  },
  {
    name: "year",
    label: "Year",
    type: "number",
    validation: {
      required: "Year is required",
      min: { value: 2000, message: "Year must be later than 2000" },
      max: {
        value: new Date().getFullYear() + 1,
        message: "Year must not be in the future",
      },
    },
  },
  {
    name: "VIN",
    label: "VIN",
    type: "text",
    validation: {
      required: "VIN is required",
      minLength: { value: 17, message: "VIN must be 17 characters" },
      maxLength: { value: 17, message: "VIN must be 17 characters" },
    },
  },
  {
    name: "engineType",
    label: "Engine Type",
    type: "text",
  },

  {
    name: "location",
    label: "Location",
    type: "text",
    validation: {
      required: "Location is required",
      maxLength: {
        value: 50,
        message: "Location must not exceed 50 characters",
      },
    },
  },
  {
    name: "transmission",
    label: "Transmission",
    type: "text",
    validation: {
      required: "Transmission is required",
      maxLength: {
        value: 50,
        message: "Transmission must not exceed 50 characters",
      },
    },
  },
  {
    name: "suspension",
    label: "Suspension",
    type: "text",
    validation: {
      required: "Suspension is required",
      maxLength: {
        value: 50,
        message: "Suspension must not exceed 50 characters",
      },
    },
  },
  {
    name: "drive",
    label: "Drive",
    type: "text",
    validation: {
      required: "Drive is required",
      maxLength: { value: 50, message: "Drive must not exceed 50 characters" },
    },
  },
  {
    name: "axleRatio",
    label: "Axle Ratio",
    type: "text",
    validation: {
      required: "Axle Ratio is required",
      maxLength: {
        value: 50,
        message: "Axle Ratio must not exceed 50 characters",
      },
    },
  },
  {
    name: "wheelbase",
    label: "Wheelbase",
    type: "text",
    validation: {
      required: "Wheelbase is required",
      maxLength: {
        value: 50,
        message: "Wheelbase must not exceed 50 characters",
      },
    },
  },
  {
    name: "brakes",
    label: "Brakes",
    type: "text",
    validation: {
      required: "Brakes is required",
      maxLength: { value: 50, message: "Brakes must not exceed 50 characters" },
    },
  },
  {
    name: "sleeper",
    label: "Sleeper",
    type: "text",
    validation: {
      required: "Sleeper is required",
      maxLength: {
        value: 50,
        message: "Sleeper must not exceed 50 characters",
      },
    },
  },

  {
    name: "mileage",
    label: "Mileage",
    type: "number",
    validation: {
      required: "Mileage is required",
      min: { value: 0, message: "Mileage must be a positive number" },
    },
  },
  {
    name: "price",
    label: "Price",
    type: "number",
    validation: {
      required: "Price is required",
      min: { value: 0, message: "Price must be a positive number" },
    },
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    validation: {
      required: "Description is required",
      maxLength: {
        value: 1000,
        message: "Description must not exceed 1000 characters",
      },
    },
  },

  {
    name: "isTruckFeatured",
    label: "Is Truck Featured",
    type: "select",
    options: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
  },
  {
    name: "isActive",
    label: "Status",
    type: "select",
    options: [
      { value: true, label: "Active" },
      { value: false, label: "Inactive" },
    ],
  }
];

export const truckForSaleInitialValues = {
  unitNumber: "",
  make: "",
  model: "",
  year: "",
  VIN: "",
  engineType: "",
  location: "",
  transmission: "",
  suspension: "",
  drive: "",
  axleRatio: "",
  wheelbase: "",
  brakes: "",
  sleeper: "",
  mileage: 0,
  price: 0,
  isTruckFeatured: false,
  isActive: false,
  description: "",
};
